'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PluginError = exports.jwtPlugin = exports.jsonPlugin = exports.events = undefined;

var _client = require('./client');

var _client2 = _interopRequireDefault(_client);

var _events = require('./events');

var events = _interopRequireWildcard(_events);

var _json = require('./plugins/json');

var _json2 = _interopRequireDefault(_json);

var _jwt = require('./plugins/jwt');

var _jwt2 = _interopRequireDefault(_jwt);

var _pluginError = require('./plugin-error');

var _pluginError2 = _interopRequireDefault(_pluginError);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.events = events;
exports.jsonPlugin = _json2.default;
exports.jwtPlugin = _jwt2.default;
exports.PluginError = _pluginError2.default;
exports.default = _client2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@synapsestudios/fetch-client/lib/index.js
// module id = 736
// module chunks = 0